module.exports = {"E":"初めて実務に挑戦する学生でも参加しやすい","D":"基本的なスキルが必要","C":"ある程度の制作・開発経験が必要","B":"高度なスキル・経験が必要","A":"非常に高度な専門性が必要","S":"特に難易度の高い特別Quest"}